var _circle, _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrees = function SvgTrees(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 49 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8805,
    cy: 12.5281,
    r: 11.0292,
    fill: "#F4F3F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3889_1977",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 46,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6013 44.3699V1.86987H4.10132V44.3699H46.6013Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3889_1977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5464 24.1012V44.741",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5461 32.7641L18.8103 28.4999",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5462 28.9736L11.3308 25.7582",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3889_1977",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 46,
    height: 46
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6013 44.3699V1.86987H4.10132V44.3699H46.6013Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3889_1977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3513 44.2088V9.93611",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3699 15.7687L28.3096 12.8289",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1827 19.7359L21.6726 16.2258",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6523 24.3882C42.7931 23.8472 42.8681 23.2797 42.8681 22.6947C42.8681 18.9907 39.8655 15.9881 36.1616 15.9881C32.4577 15.9881 29.4551 18.9907 29.4551 22.6947C29.4551 23.7632 29.7054 24.7733 30.1501 25.6699C27.3944 26.352 25.3511 28.8401 25.3511 31.8066C25.3511 35.2986 28.1819 38.1294 31.6738 38.1294C33.1571 38.1294 34.5199 37.6173 35.5982 36.7622C36.7801 37.6219 38.2346 38.1294 39.8079 38.1294C43.7646 38.1294 46.9722 34.9218 46.9722 30.9652C46.9722 28.0192 45.1938 25.4889 42.6523 24.3882Z",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5984 26.7523V44.741",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5984 30.7751L39.3148 27.0587",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5984 34.1323L32.0996 30.6335",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72998 44.741H46.9722",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9724 5.86392C46.9724 8.27476 45.018 10.2292 42.6071 10.2292C40.1963 10.2292 38.2419 8.27476 38.2419 5.86392C38.2419 3.45308 40.1963 1.49866 42.6071 1.49866C45.018 1.49866 46.9724 3.45308 46.9724 5.86392Z",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45044 30.4737C6.01234 34.5259 9.94369 37.401 14.5464 37.401C20.0535 37.401 24.5994 33.2853 25.2758 27.962",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7741 16.2584C16.7547 15.9402 15.6706 15.7686 14.5463 15.7686C9.94336 15.7686 6.01201 18.6439 4.4502 22.6962",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23482 18.6091C6.44952 19.3328 5.75888 20.1859 5.19673 21.1595C2.89527 25.1458 3.41964 29.9881 6.14819 33.3668",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8583 16.8572C32.953 16.1691 33.0018 15.4665 33.0018 14.7525C33.0018 9.08902 29.9247 4.14447 25.3513 1.49888C20.7778 4.14447 17.7007 9.08902 17.7007 14.7525C17.7007 20.416 20.7778 25.3605 25.3513 28.0062C27.0153 27.0436 28.4813 25.7766 29.6731 24.2814",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTrees;